import { amountFormatter } from './formatter'

/**
    Convert balance limits (amounts) to fit daily balance tiers
  */

export const normalizeBalanceLimits = (low: number, high: number): string => {
  if (low === 0) {
    return `Less than ${amountFormatter.format(Math.round(high))}`
  }
  const highRange =
    high < 999999999 ? `- ${amountFormatter.format(high)}` : 'or more'
  return `${amountFormatter.format(low)} ${highRange}`
}
